/**
 * Returns the platform fee rate as a percentage
 * @param subscriptionFee
 * @returns number
 */
export function platformFeeRate(subscriptionFee: number): number {
  if (subscriptionFee < 10) return 0;
  if (subscriptionFee < 20) return 50;
  if (subscriptionFee < 100) return 25;
  if (subscriptionFee < 1000) return 15;
  return 10;
}

/**
 * Returns the supplier fee rate as a percentage
 * @param subscriptionFee
 * @returns number
 */
export function supplierFeeRate(subscriptionFee: number): number {
  if (subscriptionFee < 10) return 0;
  return 100 - platformFeeRate(subscriptionFee);
}
